import type * as Types from "./copilot.types";
import { MPInstanceInsights } from "../RequestAxios/RequestAxiosInsight";
import type { TSessionType } from "@/shared/ui.types";

const getCopilotReportURL = ({
  businessPhoneNumber,
}: {
  businessPhoneNumber: string;
}) => `/phones/${businessPhoneNumber}/reports`;

const getCpaBenchmarkURL = ({ clientId }: { clientId: string }) =>
  `/clients/${clientId}/benchmarks/average-cpa`;

export const getCopilotReport = async ({
  businessPhoneNumber,
  dateFrom,
  dateTo,
  sessionType,
}: {
  businessPhoneNumber: string;
  dateFrom: string;
  dateTo: string;
  sessionType: TSessionType;
}) => {
  const { data } =
    await MPInstanceInsights.buffedInstances.get<Types.IServerResponseCopilotReport>(
      getCopilotReportURL({ businessPhoneNumber }),
      {
        params: {
          since: dateFrom,
          until: dateTo,
          wa_session_type: sessionType,
        },
      }
    );

  return data;
};

export const getCpaBenchmark = async ({ clientId }: { clientId: string }) => {
  const { data } = await MPInstanceInsights.buffedInstances.get(
    getCpaBenchmarkURL({ clientId })
  );

  return data;
};
